import * as Yup from 'yup';
import { getSelectSchema } from 'src/compass/shared/schemas';

export const AccountSchema = Yup.object().shape({
  entityObj: getSelectSchema('Entity'),
});
